import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import dayjs from 'dayjs';
import { dateFormat } from '../../../tools/date';
import { mapNumber } from '../../../tools/map-number';
import { SupaStatisticsApi } from '../../../data/supa-statistics/supa-statistics.api';
import { JournalDayStatsViewModel } from '../../../data/supa-statistics/journal-day-stats-view-model';
import { createJournalDayStatsViewModel } from '../../../data/supa-statistics/create-journal-day-stats-view-model';


@Component({
  selector: 'app-journal-day-activity-calendar',
  templateUrl: './journal-day-activity-calendar.component.html',
  styleUrls: ['./journal-day-activity-calendar.component.scss']
})
export class JournalDayActivityCalendarComponent implements OnInit {
  statisticsApi = inject(SupaStatisticsApi);

  @Input() mode: 'week' | 'month' = 'month';

  @Output() dayClicked = new EventEmitter<string>();

  vm?: JournalDayStatsViewModel;

  constructor() {

  }

  async ngOnInit() {
    const startDate = dayjs()
      .subtract(1, 'year')
      // .startOf('week')
      .startOf(this.mode)
      .format(dateFormat);

    const endDate = dayjs()
      .format(dateFormat);

    const dayStats = await this.statisticsApi.dayStats(
      startDate,
      endDate
    )

    this.vm = createJournalDayStatsViewModel(
      startDate,
      endDate,
      dayStats,
      'month'
    )
  }

  iHateAlpha(charAmount: number) {
    return mapNumber(charAmount, 0, this.vm?.maxCharsOfDay || 0, 0, 1);
  }


}
